// src/data/footerData.js

export const footerGridLinks = [
  {
    title: "Collections",
    links: [
      { name: "Bulk Gifts", url: "#" },
      { name: "Welcome Kit For New Employees", url: "#" },
      { name: "Branded Gifts", url: "#" },
      { name: "Eco Friendly Gifts", url: "#" },
      { name: "Thank You Gifts", url: "#" },
      { name: "Tech Gifts", url: "#" },
      { name: "Stationery Gifts", url: "#" },
    ],
  },
  {
    title: "Occasions",
    links: [
      { name: "Birthday Gifts", url: "#" },
      { name: "Company Anniversary Gifts", url: "#" },
      { name: "Rewards and Recognition", url: "#" },
      { name: "Women's day Gifts for Employees", url: "#" },
      { name: "New Year Gifts", url: "#" },
      { name: "Executive Gifts", url: "#" },
      { name: "Christmas Gifts", url: "#" },
    ],
  },
  {
    title: "Stores",
    links: [
      { name: "Bhopal", url: "#" },
      // { name: "Chennai", url: "#" },
      // { name: "Hyderabad", url: "#" },
      // { name: "Pune", url: "#" },
      // { name: "Delhi", url: "#" },
      // { name: "Mumbai", url: "#" },
      // { name: "Ahmedabad", url: "#" },
    ],
  },
  {
    title: "By Prices",
    links: [
      { name: "Gifts Under 1000", url: "#" },
      { name: "Gifts Under 2500", url: "#" },
      { name: "Gifts Under 3000", url: "#" },
      { name: "Gifts Above 3000", url: "#" },
    ],
  },
];

export const footerSeoLinks = [
  {
    title: "Premium Diaries & Journals",
    links: [
      { name: "Buy Premium Diaries Online", url: "#" },
      { name: "Daily Gratitude Journals", url: "#" },
      { name: "Personalized Notebooks", url: "#" },
      { name: "Ruled & Unruled Notebooks", url: "#" },
      { name: "Custom Pocket Notepads", url: "#" },
      { name: "Leather Bound Diaries", url: "#" },
      { name: "Undated Planners & Journals", url: "#" },
      { name: "Aesthetic Desk Notepads", url: "#" },
    ],
  },
  {
    title: "Memories & Art Collection",
    links: [
      { name: "Custom Photobooks Online", url: "#" },
      { name: "Personalized Photo Albums", url: "#" },
      { name: "Wedding & Anniversary Albums", url: "#" },
      { name: "Travel Books & Journals", url: "#" },
      { name: "Premium Sketchbooks for Artists", url: "#" },
      { name: "Hardcover Sketchbooks", url: "#" },
      { name: "Scrapbook Photo Albums", url: "#" },
      { name: "Family Memory Photobooks", url: "#" },
    ],
  },
  {
    title: "Corporate & Desk Essentials",
    links: [
      { name: "Corporate Gift Hampers", url: "#" },
      { name: "Custom Table Calendars 2026", url: "#" },
      { name: "Office Desk Calendars", url: "#" },
      { name: "Diaries for Corporate Gifting", url: "#" },
      { name: "Welcome Hampers for Employees", url: "#" },
      { name: "Bulk Notebooks for Office", url: "#" },
      { name: "Executive Diaries & Pens", url: "#" },
    ],
  },
  {
    title: "Trending Stationery Gifts",
    links: [
      { name: "Gifts for Writers & Artists", url: "#" },
      { name: "Travel Journals for Men & Women", url: "#" },
      { name: "Birthday Gift Photobooks", url: "#" },
      { name: "Eco-Friendly Notebooks", url: "#" },
      { name: "Custom Printed Table Calendars", url: "#" },
      { name: "Luxury Stationery Hampers", url: "#" },
      { name: "Buy Sketchbooks in Bulk", url: "#" },
    ],
  },
];

// Payment methods with CDN logo URLs (image 1 mein dikhe hue exactly same)
export const paymentMethods = [
  {
    name: "Airtel",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9b/Airtel_logo.svg/320px-Airtel_logo.svg.png",
  },
  {
    name: "Amazon Pay",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b0/Amazon_Pay_logo.svg/320px-Amazon_Pay_logo.svg.png",
  },
  {
    name: "Google Pay",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f2/Google_Pay_Logo.svg/320px-Google_Pay_Logo.svg.png",
  },
  {
    name: "BHIM",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e8/BHIM_Logo_with_text.svg/320px-BHIM_Logo_with_text.svg.png",
  },
  {
    name: "Mastercard",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2a/Mastercard-logo.svg/320px-Mastercard-logo.svg.png",
  },
  {
    name: "Mobikwik",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6e/Mobikwik_logo.png/320px-Mobikwik_logo.png",
  },
  {
    name: "Ola Money",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/32/Ola_Cabs_logo.svg/320px-Ola_Cabs_logo.svg.png",
  },
  {
    name: "RuPay",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d1/RuPay.svg/320px-RuPay.svg.png",
  },
  {
    name: "PayPal",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b5/PayPal.svg/320px-PayPal.svg.png",
  },
  {
    name: "Paytm",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/24/Paytm_Logo_%28standalone%29.svg/320px-Paytm_Logo_%28standalone%29.svg.png",
  },
  {
    name: "Visa",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5e/Visa_Inc._logo.svg/320px-Visa_Inc._logo.svg.png",
  },
];

export const footerMeta = {
  timings: "10:00am - 6:00pm IST, Monday - Saturday",
  phone: "+91-9406515526",
  email: "info@aishcraft.com",
  copyright: "© 2026, Aishcraft Gifting",
  whatsappNumber: "9406515526",
  // Yahan message ko customize karein
  whatsappLink: `https://wa.me/919406515526?text=${encodeURIComponent("Hello Aishcraft, I would like to know more about your gifting products!")}`
};